// @ts-expect-error - TS2614 - Module '"src/api-parsers/index"' has no exported member 'Workflow'. Did you mean to use 'import Workflow from "src/api-parsers/index"' instead?
import type {Workflow} from 'src/api-parsers/index';
import type {Question} from 'src/types/survey';
// @ts-expect-error - TS2614 - Module '"src/api-parsers/events"' has no exported member 'Event'. Did you mean to use 'import Event from "src/api-parsers/events"' instead?
import type {Event} from 'src/api-parsers/events';

import type {BranchInfo} from 'src/stores/event-creation';
import type {DynamicLabels} from 'src/types/dynamic-labels';

import * as React from 'react';

import Modules from 'src/components/workflow/event/content/modules';


const BranchModules = (props: {
  showErrors?: boolean;
  workflow: Workflow;
  branchInfo: BranchInfo;
  editingQuestion: Question;
  questionError: Record<any, any> | null | undefined;
  dynamicLabels: string[];
  conditionalAlerts: boolean;
  jobDynamicLabels: DynamicLabels;
  isBranchedEvent: boolean;
  parentEvent?: Event;
}) => (
  <Modules
    {...props}
    // @ts-expect-error - TS2339 - Property 'questions' does not exist on type 'Branch'.
    modules={props.branchInfo.branch.questions}
    parentType="branch"
    parentEvent={props.parentEvent}
  />
);

export default BranchModules;
